import { api } from "./axios";
import { Changes } from "../types";

export function getChangeRequests() {
  return api.get("change-requests/");
}

export function createChangeRequest(
  clientId: string | number,
  changes: Changes,
  profileId?: string
) {
  return api.post("change-requests/", {
    client: clientId,
    changes,
    ...(profileId ? { profile_id: profileId } : {}),
  });
}

export function deleteChangeRequest(clientId: number) {
  return api.post(`change-requests/reject/${clientId}/`);
}

export function notifyChangeRequest(clientId: number, profileId?: string) {
  return api.post(
    `change-requests/notify/${clientId}/`,
    profileId ? { profile_id: profileId } : undefined
  );
}

export function acceptChangeRequest({
  clientId,
  otp,
  investorIP,
  profileId,
}: {
  clientId: number;
  otp: string;
  investorIP: string;
  profileId?: string;
}) {
  return api.post(`change-requests/accept/${clientId}/`, {
    otp,
    investor_ip: investorIP,
    ...(profileId ? { profile_id: profileId } : {}),
  });
}

export function rejectChangeRequest(clientId: number, profileId?: string) {
  return api.post(
    `change-requests/reject/${clientId}/`,
    profileId ? { profile_id: profileId } : undefined
  );
}

export interface ChangeSet {
  id: number;
  client_id: number;
  items: Array<{
    field_name: string;
    has_changes: boolean;
    id: number;
    new_value: string;
    object_pk: string;
    profile_id?: string | null;
    old_value: string;
    target_model: keyof Changes;
  }>;
}

export function getChangeRequestByClientId(
  clientId: number
): Promise<ChangeSet> {
  return api.get(`change-requests/retrieve-by-client/${clientId}/`);
}

export function getChangeRequestById(id: number) {
  return api.get(`change-requests/${id}/`);
}
